define('views/content/reports/customers',['require','backbone','marionette','datatables','select2','text!templates/content/reports/customers.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('datatables');
    require('select2');

    var temp = require("text!templates/content/reports/customers.html");

    return Backbone.Marionette.CompositeView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'report-page',
        titleKey: 'customers',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',

                localizationFilter: '#localization',
                versionFilter: '#versions',
                countryFilter: '#countries',
                cityFilter: '#city',

                getReportButton: '#report-button',
                getCsvButton: '#csv-button',

                customersTable: '.customers-list',
                totalCount: '#total_count'
            };
        },

        events: {
            'click @ui.getReportButton': 'getReportButtonClicked',
            'click @ui.getCsvButton': 'getCsvButtonClicked'
        },

        onRender: function () {
            this.ui.select2Input.select2();
        },

        _getParameters: function() {
            var parameters = '';

            parameters += ('localization=' + this.ui.localizationFilter.val());

            if (this.ui.versionFilter.val()) {
                this.ui.versionFilter.val().forEach(function (versionFilter) {
                    parameters += ('&versions[]=' + versionFilter);
                });
            }


            if (this.ui.countryFilter.val()) {
                this.ui.countryFilter.val().forEach(function (countryFilter) {
                    parameters += ('&countries[]=' + countryFilter);
                });
            }

            if (this.ui.cityFilter.val()) {
                parameters += ('&city=' + this.ui.cityFilter.val());
            }


            return parameters;
        },

        getReportButtonClicked: function() {
            this.getReports();
        },

        getCsvButtonClicked: function() {
            $.ajax({
                url: App.Config.apiBase + 'reports/customer-data-reports/?' + this._getParameters(),
                method: 'get',
                headers: { 'Accept': 'text/csv' },
                success: function (response) {
                    var encodedUri = encodeURI("data:text/csv;charset=utf-8," + response);
                    var link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    link.setAttribute("target", "_blank");
                    link.setAttribute("class", "out");
                    link.setAttribute("download", "customers.csv");
                    document.body.appendChild(link); // Required for FF
                    link.click();
                }
            });
        },

        getReports: function () {
            var _this = this;

            $.ajax({
                url: App.Config.apiBase + 'reports/customer-data-reports/?' + this._getParameters(),
                method: 'get',
                success: function (response) {
                    _this.showCustomerReports(response);
                }
            });
        },

        showCustomerReports: function (reportData) {
            this.ui.totalCount.html(reportData.length);

            // Transform report data for datatables format
            var gridData = [];

            reportData.forEach(function (reportRow) {
                gridData.push([
                    '<a href="/customers/' + reportRow.customer_id + '">' + reportRow.company_name + '<a/>',
                    '<a href="/customer-managers/' + reportRow.manager_id + '">' + reportRow.manager_name + '<a/>',
                    reportRow.manager_email,
                    reportRow.manager_phone_number,
                    reportRow.country,
                    reportRow.city
                ]);
            });

            if (!this.customersDataTable) {
                this.customersDataTable = this.ui.customersTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: gridData,
                    fixedHeader: true,
                    scrollY: App.utils.getContainerHeightWOffset(this.ui.customersTable),
                    columns: [
                        { title: App.polyglot.t('customer') },
                        { title: App.polyglot.t('manager') },
                        { title: App.polyglot.t('email') },
                        { title: App.polyglot.t('phone_number') },
                        { title: App.polyglot.t('country') },
                        { title: App.polyglot.t('city') }
                    ],
                    buttons: [
                        'print'
                    ]
                });
            } else {
                this.customersDataTable.clear();
                this.customersDataTable.rows.add(gridData);
                this.customersDataTable.columns.adjust().draw();
            }
        }

    });
});
